import React, { useMemo } from "react";
import GlobalMetricCards from "../../../../global/GlobalMetricCards";

const formatAmount = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return "₹0";
  return `₹${n.toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
};

const ADMIN_METRICS = (stats) => [
  {
    label: "Total Cheques",
    value: stats.total_cheques ?? 0,
    tone: "slate",
    chartHeights: [0.4, 0.55, 0.5, 0.65, 0.6],
  },
  {
    label: "Issued Cheques",
    value: stats.issued_cheques ?? 0,
    tone: "coral",
    chartHeights: [0.5, 0.6, 0.45, 0.7, 0.55],
  },
  {
    label: "Cleared Cheques",
    value: stats.cleared_cheques ?? 0,
    tone: "mint",
    chartHeights: [0.45, 0.65, 0.75, 0.85, 0.8],
  },
  {
    label: "Pending Cheques",
    value: stats.pending_cheques ?? 0,
    tone: "teal",
    chartHeights: [0.6, 0.5, 0.55, 0.45, 0.5],
  },
  {
    label: "Cancelled Cheques",
    value: stats.cancelled_cheques ?? 0,
    tone: "slate",
    chartHeights: [0.3, 0.35, 0.25, 0.4, 0.2],
  },
  {
    label: "Total Cheque Amount",
    value: formatAmount(stats.total_cheque_amount),
    tone: "mint",
    chartHeights: [0.5, 0.7, 0.8, 0.9, 1.0],
  },
];

const STAFF_METRICS = (stats) => [
  {
    label: "Total Issued",
    value: stats.issued_cheques ?? 0,
    tone: "coral",
    chartHeights: [0.5, 0.6, 0.45, 0.7, 0.55],
  },
  {
    label: "Cleared",
    value: stats.cleared_cheques ?? 0,
    tone: "mint",
    chartHeights: [0.45, 0.65, 0.75, 0.85, 0.8],
  },
  {
    label: "Pending",
    value: stats.pending_cheques ?? 0,
    tone: "teal",
    chartHeights: [0.6, 0.5, 0.55, 0.45, 0.5],
  },
  {
    label: "Cancelled",
    value: stats.cancelled_cheques ?? 0,
    tone: "slate",
    chartHeights: [0.3, 0.35, 0.25, 0.4, 0.2],
  },
  {
    label: "Bounced",
    value: stats.bounced_cheques ?? 0,
    tone: "coral",
    chartHeights: [0.35, 0.5, 0.4, 0.55, 0.45],
  },
];

const ChequeSummaryWidgets = ({ loading, dashboardStats, variant = "admin" }) => {
  const stats = dashboardStats || {};

  const metricItems = useMemo(() => {
    const build =
      variant === "staff" ? STAFF_METRICS : ADMIN_METRICS;
    return build(stats);
  }, [stats, variant]);

  return (
    <div className="ochq-panel">
      <div className="ochq-panel__header">
        <h2 className="ochq-panel__title">Dashboard Overview</h2>
        <p className="ochq-panel__hint" style={{ margin: 0, fontSize: "0.8125rem", color: "#64748b" }}>
          Counts are grouped by names in cheque statuses master data.
        </p>
      </div>
      <GlobalMetricCards
        items={metricItems}
        loading={loading}
        skeletonCount={variant === "staff" ? 5 : 6}
        ariaLabel="Cheque dashboard metrics"
      />
    </div>
  );
};

export default ChequeSummaryWidgets;
